// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1tsKe","actionsCol":"EnrolledClinics_actionsCol__1U_Qy"};